export default __webpack_public_path__ + "static/media/4.db039ea8.jpg";